<ul>
    <li *ngFor="let category of categories">
        <!-- TREE NODE -->
        <div class="tree-node"
             *ngIf="category.isVisible && (category.children?.length || category.dependencies?.length)">
            <mat-checkbox [checked]="category.isSelected"
                          [indeterminate]="category.someSelected"
                          (change)="onCategorySelected(category, true)"
                          *ngIf="category.dependencies?.length"></mat-checkbox>
            <button mat-icon-button
                    *ngIf="!isRoot"
                    (click)="onToggleItem(category)">
                <mat-icon>{{ category.isOpen ? 'expand_more' : 'chevron_right' }}</mat-icon>
            </button>
            <span class="label"
                  *ngIf="!isRoot">
                {{ category.text ? category.text.fullLabel : category.label}}
            </span>
        </div>

        <!-- DEPENDENCIES -->
        <div class="deps">
            <app-items-list [items]="category.dependencies"
                            [selection]="selection"
                            (itemSelected)="onItemSelected($event, category)"
                            *ngIf="category.dependencies?.length && category.isOpen"></app-items-list>
        </div>

        <!-- CHILDREN -->
        <app-selection-category [categories]="category.children"
                                [depsLabel]="depsLabel"
                                [selection]="selection"
                                (itemSelected)="onItemSelected($event)"
                                (categorySelected)="onCategorySelected($event)"
                                *ngIf="category.children?.length && category.isOpen"></app-selection-category>
    </li>
</ul>